import { Modal } from "antd";
import React from "react";
import PickerMedicineBoxLog from "../PickerMedicineBoxLog/PickerMedicineBoxLog";

export class PickerMedicineBoxLogModal extends React.Component {
  state = {};
  render() {
    let { openMedicineBoxLog, toggleMedicineBoxLog } = this.props;
    return (
      <div>
        <Modal
          title="Medicine Box Log"
          open={openMedicineBoxLog}
          centered
          onCancel={() => toggleMedicineBoxLog(false)}
          className="medBoxLogModal"
          footer={null}
        >
          <PickerMedicineBoxLog
            toNumber={this.props.toNumber}
            medBoxLogFailure={this.props.medBoxLogFailure}
            medBoxLogSuccess={this.props.medBoxLogSuccess}
            access_token={this.props.access_token}
          />
        </Modal>
      </div>
    );
  }
}

export default PickerMedicineBoxLogModal;
